import { createSlice } from "@reduxjs/toolkit";

import { ServerError } from "@/lib/types";

import { addSpecialist, deleteSpecialist, getSpecialist, getSpecialists, updateSpecialist } from "@/store/actions/specialists-actions";
import { SpecialistsState } from "@/store/types";

const initialState: SpecialistsState = {
  loading: false,
  error: "",
  users: null,
  selected: null,
};

const specialistsSlice = createSlice({
  name: "specialists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ============= get specialists =============
      .addCase(getSpecialists.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSpecialists.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.users = payload;
      })
      .addCase(getSpecialists.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload?.message ?? "";
      })
      // ============= get specialist =============
      .addCase(getSpecialist.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSpecialist.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.selected = payload;
      })
      .addCase(getSpecialist.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload?.message ?? "";
      })
      // ============= new specialist =============
      .addCase(addSpecialist.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(addSpecialist.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.selected = payload;
      })
      .addCase(addSpecialist.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload.message ?? "";
      })
      // ============= update specialist =============
      .addCase(updateSpecialist.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(updateSpecialist.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.selected = payload;
      })
      .addCase(updateSpecialist.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload?.message ?? "";
      })
      // ============= delete specialist =============
      .addCase(deleteSpecialist.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(deleteSpecialist.fulfilled, (state) => {
        state.loading = false;
        state.users = state.users?.filter(user => user.id !== state.selected?.id) || [];
        state.selected = null;
      })
      .addCase(deleteSpecialist.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload?.message ?? "";
      })
  }
});

export default specialistsSlice.reducer;
